import { runtimeEnv } from 'config/runtimeEnv';
import { setCurrentUser } from 'utils/utils';
import { API_ENDPOINT } from './Api';
import requestInstance from './Request';

let env = runtimeEnv('B2B_API_BASE_URL');

export const getSettlementList = async (payload) => {
  const payloadData = {
    search: payload?.search ? payload?.search : '',
    status: payload?.status ? payload?.status : '',
    pageSize: payload?.pageSize ? payload?.pageSize : '',
    dateFrom: payload?.dateFrom ? payload?.dateFrom : '',
    dateTo: payload?.dateTo ? payload?.dateTo : '',
  };
  const page = payload?.page === 0 || payload?.page ? payload?.page + 1 : 1;

  let url = '';
  if (payload.id) {
    url = `${env}${API_ENDPOINT.settlement.api}${'/' + payload?.id}`;
  } else {
    url = `${env}${
      API_ENDPOINT.settlement.api +
      '?search=' +
      payloadData?.search +
      '&page=' +
      page +
      '&status=' +
      payloadData?.status +
      '&pageSize=' +
      payloadData?.pageSize +
      '&dateTo=' +
      payloadData?.dateTo +
      '&dateFrom=' +
      payloadData?.dateFrom
    }`;
  }

  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const getSettlementDetails = async (payloadId) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.settlement.api}${payloadId}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const addSettlement = async (data) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.settlement.api}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const updateSettlement = async (payloadData, payloadId) => {
  let data = {};
  let id = '';

  if (payloadData?.formData?.type) {
    data = payloadData?.formData;
    id = payloadData?.id;
  } else {
    data = payloadData;
    id = payloadId;
  }

  const res = await requestInstance
    .patch(`${env}${API_ENDPOINT.settlement.api}/${id}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getConsolidatedInvoice = async (payload) => {
  const payloadData = {
    city: payload?.city ? payload?.city : '',
    pageSize: payload?.pageSize ? payload?.pageSize : '',
    dateFrom: payload?.dateFrom ? payload?.dateFrom : '',
    dateTo: payload?.dateTo ? payload?.dateTo : '',
    companyId: payload?.companyId ? payload?.companyId : '',
  };
  const page = payload?.page === 0 || payload?.page ? payload?.page + 1 : 1;
  const res = await requestInstance
    .get(
      `${env}${
        API_ENDPOINT.settlement.consolidateInvoice +
        '?page=' +
        page +
        '&city=' +
        payloadData?.city +
        '&pageSize=' +
        payloadData?.pageSize +
        '&dateTo=' +
        payloadData?.dateTo +
        '&dateFrom=' +
        payloadData?.dateFrom +
        '&isCompletelySettled=' +
        'false' +
        '&companyId=' +
        payloadData?.companyId
      }`,
    )
    .catch((err) => err.response);
  return setCurrentUser(res);
};
